/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, Input, ViewChild } from '@angular/core';
import { TooltipItem } from 'chart.js';
import 'chartjs-adapter-date-fns';
import { BaseChartDirective } from 'ng2-charts';
import { AggregationTrendSeries, PointInTime, noTransform } from 'src/app/models/api/dashboards.model';
import { BeautifyDisplayStringPipe } from 'src/app/pipes/beautify-display-string/beautify-display-string.pipe';
import { YAxisType, newDefaultChartOptions } from './chartConfig';

const defaultColor = '#0000ff';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent {
  public chartOptions: any = newDefaultChartOptions();

  public noData = false;

  @Input() public title: string;
  @Input() public tooltip: string;

  @Input() public set yAxisLabelType(type: keyof typeof YAxisType) {
    if (type === YAxisType.percent) {
      this.chartOptions.scales['y'].ticks.callback = (value: string) => `${value}%`;
    }
  }

  @Input() public set seriesDetails(series: AggregationTrendSeries[]) {
    this.noData = series.length === 0;

    this.chartDatasets = series.map((series) => ({
      tension: 0.4,
      data: (series.transform.seriesTransformationFunc ?? noTransform)(series.data ?? []),
      label: this._beautifyDisplayStringPipe.transform(series.name),
      borderColor: series.transform?.color ?? defaultColor,
      pointBackgroundColor: series.transform?.color ?? defaultColor,
      pointHitRadius: 10,
      pointRadius: 0,
    }));

    this.chartOptions.plugins.tooltip.callbacks.label = (tooltip: TooltipItem<'line'>) =>
      (tooltip.raw as PointInTime)?.tooltip ?? tooltip.formattedValue;

    setTimeout(() => this.chart?.update(), 250);
  }

  @ViewChild(BaseChartDirective) public chart?: BaseChartDirective;

  public chartDatasets: any;

  constructor(private readonly _beautifyDisplayStringPipe: BeautifyDisplayStringPipe) {}
}
